import getEndpoints from './endpoints/index';

let baseEndpoint = {
    local: 'http://localhost:3050',
    prod: '',  
    stage: '',  
    test: '',
};

const EndpointSources = {
    remote: () => ({
        oauth: getBaseURL() + '/oauth',
    }),

    local: () => ({
        oauth: `${baseEndpoint.local}/oauth`,
    }),
};

// https://accounts.google.com/o/oauth2/auth/oauthchooseaccount


export const googleOauthSettings = {
    APPS_URL: 'apps.googleusercontent.com',
    // OAUTH_URL: 'https://accounts.google.com/o/oauth2/v2/auth?',
    OAUTH_URL: 'https://accounts.google.com/o/oauth2/auth?',

    defaultIds: {
        test: '323724636018-fkl9qkdh8a9sb1s67424tbbhp77gbkkl',
        stage: '323724636018-fkl9qkdh8a9sb1s67424tbbhp77gbkkl',
        prod: '921894458693-mbfubssabhc5lnbvinkp6s1hurb2peai',    
    },
   
    clients: {
        stage: {
            '14277':  '323724636018-fkl9qkdh8a9sb1s67424tbbhp77gbkkl',
            '14282': '323724636018-fkl9qkdh8a9sb1s67424tbbhp77gbkkl',
        },

        prod: {
            '476117': '51901841353-gulvd8tacblsg82smo7q7jgl3lg92vqe',
        },
    },
}

export const outlookOauthSettings = {
    APPS_URL: 'apps.googleusercontent.com',
    // OAUTH_URL: 'https://accounts.google.com/o/oauth2/v2/auth?',
    OAUTH_URL: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize?',

    defaultIds: {
        test: 'b7ab0493-750f-4758-9473-2a2a05762914',
        stage: 'b7ab0493-750f-4758-9473-2a2a05762914',
        prod: '7664fbd2-7f40-4bef-a678-17593dc5df0c',    
    },
   
    clients: {
        stage: {
            '14277':  'b7ab0493-750f-4758-9473-2a2a05762914',
            '14282': 'b7ab0493-750f-4758-9473-2a2a05762914',
        },

        prod: {
            '476117': '7664fbd2-7f40-4bef-a678-17593dc5df0c',
        },
    },
}

 


export function getBaseURL() {
    if (baseEndpoint[window.env]) {
        return baseEndpoint[window.env];
    }
    return baseEndpoint.test;
}

export function endpoints() {
    
    baseEndpoint = getEndpoints(window.envStore.subdomain);
    
    console.log('Base Endpoint -> ', baseEndpoint);
    console.log('Endpoints IS Called...', window.envStore.subdomain);
    if (window.env !== undefined && window.env !== 'local') {
        return EndpointSources.remote();
    }

    return EndpointSources.local();
}
